import React from "react";

import { CurrencyInput } from "components/CurrencyInput";
import { Singleton } from "helper/tools";

import invalidClass from "components/proto/helperFunctions/helpers";

function PagoTableCell({
  aItem,
  index,
  productoAbono,
  errorProductosAmount,
  handleAmountChange,
}) {
  let isInteres = true;
  let nombreProducto = "INTERES";
  let totalPendiente = aItem?.totalPendiente;
  let adeudoTotal = aItem?.totalPendiente;
  if (aItem?.type === "producto") {
    isInteres = false;
    nombreProducto = aItem?.producto.nombre;
    totalPendiente = aItem?.parcialidadActual.totalPendiente;
    adeudoTotal = aItem?.productoParcialidad.totalPendiente;
  }

  const totalPendienteFormat = Singleton.getInstance().format(totalPendiente);
  const adeudoTotalFormat = Singleton.getInstance().format(adeudoTotal);

  console.log(
    `--> Render table buidlROW INSIDE: ${productoAbono} index: ${index}`,
  );

  return (
    <tr className="table-active align-middle">
      <th scope="row">{index + 1}</th>
      <td>{nombreProducto}</td>
      <td>{totalPendienteFormat}</td>
      <td>{adeudoTotalFormat}</td>
      <td>
        <div>
          <div
            className={`input-group ${invalidClass(errorProductosAmount[index])}`}
          >
            <CurrencyInput
              initialValue={productoAbono}
              value={productoAbono}
              className={`form-control remove-padding  ${invalidClass(errorProductosAmount[index])}`}
              placeholder="Cantidad a Agregar"
              onNewValueHandler={(value) => {
                handleAmountChange(value, index);
              }}
            />
          </div>
        </div>
      </td>
    </tr>
  );
}

export default PagoTableCell;
